import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.reduce";
import mergeWith from 'lodash/mergeWith';
import fclone from 'fclone';

function normalizeResolvers(resolvers) {
  if (resolvers.dependencies != null && typeof resolvers.dependencies !== 'function') {
    return resolvers;
  }

  return {
    dependencies: {},
    resolvers: resolvers
  };
}

export default function mergeResolvers() {
  for (var _len = arguments.length, resolvers = new Array(_len), _key = 0; _key < _len; _key++) {
    resolvers[_key] = arguments[_key];
  }

  return resolvers.reduce(function (memo, resolvers) {
    Object.keys(resolvers).forEach(function (type) {
      var typeResolvers = fclone(normalizeResolvers(resolvers[type]));

      if (memo[type] != null) {
        mergeWith(memo[type].dependencies, typeResolvers.dependencies, function (objValue, srcValue, key, object) {
          if (object.hasOwnProperty(key)) {
            // Duplicated resolver function
            throw new Error("Duplicated key \"".concat(key, "\" found when merging resolvers for type \"").concat(type, "\""));
          }
        });
        mergeWith(memo[type].resolvers, typeResolvers.resolvers, function (objValue, srcValue, key, object) {
          if (object.hasOwnProperty(key)) {
            // Duplicated resolver function
            throw new Error("Duplicated key \"".concat(key, "\" found when merging resolvers for type \"").concat(type, "\""));
          }
        });
      } else {
        memo[type] = typeResolvers;
      }
    });
    return memo;
  }, {});
}